import { Command } from '@nest/internal-frontend';
import { FileText } from 'lucide-react';

export const useCommandInboundDeliveryOrderOpenDocument = ({
	inboundDeliveryOrder,
	auth,
	onOpenDocument
}: {
	inboundDeliveryOrder: { id: number; state: string; assignedTo?: { id: number } } | undefined;
	auth: { identity?: { id: number } };
	onOpenDocument: () => void;
}): Command => {
	const isInProgress = inboundDeliveryOrder?.state === 'InProgress';
	const isAssignedToMe = inboundDeliveryOrder?.assignedTo?.id === auth.identity?.id;
	const canOpen = Boolean(isInProgress && isAssignedToMe && inboundDeliveryOrder);

	return {
		id: 'open-document',
		label: 'Otevřít doklad',
		icon: <FileText className="h-4 w-4" />,
		shortcut: undefined,
		disabled: !canOpen,
		loading: undefined,
		run: async () => {
			onOpenDocument();
		}
	};
};
